import { Routes } from '../routes';
import { MenuCodes } from '../../constants';

export const items = [
  {
    [MenuCodes.HOME]: Routes.HOME,
    [MenuCodes.ACTIVATE_ACCOUNT]: Routes.ACTIVATE_ACCOUNT,
  },
  {
    [MenuCodes.PAYMENT_LINK]: {
      [MenuCodes.CREATED_PAYMENT_LINKS]: Routes.CREATED_PAYMENT_LINKS,
      [MenuCodes.CREATE_PAYMENT_LINK]: Routes.CREATE_PAYMENT_LINK,
    },
    [MenuCodes.VIRTUAL_POS]: Routes.VIRTUAL_POS,
    [MenuCodes.PAYMENT_BUTTON]: Routes.PAYMENT_BUTTON,
    [MenuCodes.PAYMENT_INTEGRATION]: Routes.PAYMENT_INTEGRATION,
  },
  {
    [MenuCodes.TRANSACTIONS]: Routes.TRANSACTIONS,
    [MenuCodes.REFUNDS]: Routes.REFUNDS,
    [MenuCodes.SETTLEMENTS]: Routes.SETTLEMENTS,
    [MenuCodes.BANK_ACCOUNTS]: Routes.BANK_ACCOUNTS,
  },
  {
    [MenuCodes.COMPANY_INFORMATION]: Routes.COMPANY_INFORMATION,
    [MenuCodes.PAYMENT_METHODS]: Routes.PAYMENT_METHODS,
    [MenuCodes.CLIENTS]: Routes.CLIENTS,
  },
];
